export enum ExpiresPresetEnum {
	_1_HOUR = '1 hour',
	_17_00_CET = '17:00 CET',
}
